import { CopyArtefactLinkButton } from '@modules/common/components/CopyArtefactLinkButton';
import { ArtefactType } from '@modules/common/types';
import { trackSearchV2Events } from '@modules/feed/components/BasicSearchDropdown/BasicSearchDropdownV2';
import { ResetSearchAction } from '@modules/feed/components/ResetSearchAction';
import { SaveSearchActions } from '@modules/feed/components/SearchAnalysisToolbar/Actions';
import { isSavedSearch } from '@modules/feed/components/SearchAnalysisToolbar/utils';
import { SearchSubscribeFeedbackV2 } from '@modules/feed/components/SearchSubscribeFeedback';
import { useSaveSearchDashboard } from '@modules/feed/hooks';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { Box } from '@mui/material';
import { useMemo } from 'react';

export const useGetSearchRightActions = () => {
  const id = useSearchStore(({ data: { id } = {} }) => id);
  const { onSaveSearchDashboard } = useSaveSearchDashboard();

  const onCopyClick = (link: string) =>
    trackSearchV2Events({
      eventName: 'Search share link copied',
      url: link,
    });

  const rightActions = useMemo(
    () => [
      {
        component: <ResetSearchAction />,
        key: 'Reset Search',
      },
      {
        component: (
          <Box>
            <CopyArtefactLinkButton
              artefactType={ArtefactType.Search}
              artefactLink={`${window.location.origin}${window.location.pathname}`}
              onClick={onCopyClick}
              onSave={onSaveSearchDashboard}
              isSavedArtefact={isSavedSearch(id)}
            />
          </Box>
        ),
        key: 'Copy Search Link',
      },
      {
        component: <SaveSearchActions />,
        key: 'Save Search',
      },
      {
        component: <SearchSubscribeFeedbackV2 />,
        key: 'Subscribe Feedback',
      },
    ],
    [id, onSaveSearchDashboard],
  );

  return rightActions;
};
